// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

var AdminController = function ($scope, $http, AdminUser, Settings, DeploymentInfo, Signup) {

    var roles = {
        "Readonly": "Readonly",
        "Admin": "Admin",
        "Translator": "Translator",
        "Supporter": "Supporter",
        "SuperAdmin": "SuperAdmin"
    };
    Object.freeze(roles);

    function init() {
        $scope.roles = roles;
        $scope.email = "";
        $scope.assignedRole = roles.Readonly;
        $scope.signup = new Signup();
        $scope.deploymentInfo = DeploymentInfo.get();

        if ($scope.adminOrInRole([])) {
            $scope.users = AdminUser.query(function (users) {
                $scope.unconfirmedUsers = users.filter(function (user) { return user.AdminUserInvitationStatus !== 'Confirmed';});
            });

            $scope.settings = Settings.get();
        }
    }

    init();

    function saveSettings() {
        $scope.settings.$update({}, function (data) {
            $scope.notify("success", "saved successfully");
        });
    }

    $scope.saveSettings = function () {
        $scope.confirm('Save settings', 'Are you sure you want to save new settings?', saveSettings);
    };

    $scope.updateSettingsOnInstanceModeChange = function () {
        $scope.settings.ProductDemoButtonEnabled = false;
        $scope.settings.AutomaticallyGenerateDemoData = false;
    }

    function deleteAdminUser(id) {
        $http.delete("/api/v1/adminUsers/" + id).success(function () {
            $scope.users = AdminUser.query();
        });
    }

    $scope.deleteAdminUser = function (id) {
        $scope.confirm("User deletion", "Are you sure you want to delete the user with id '"+ id + "'?", deleteAdminUser.bind(this, id));
    }
    
    $scope.invite = function () {
        $scope.confirm("User invitation", "Are you sure you want to invite user with email '" + $scope.email + "'?",
            dispatchInvitation.bind(this, $scope.email, $scope.assignedRole));
    }

    $scope.reinvite = function (user) {
        dispatchInvitation(user.EmailAddress, user.Role);
    }

    function dispatchInvitation(email, assignedRole) {

        $scope.signup.EmailAddress = email;
        $scope.signup.assignedRole = assignedRole;

        $scope.signup.$save({}, function () {
            init();
        }, function () {
            init();
        });
    };
};
AdminController.$inject = ["$scope", "$http", "AdminUser", "Settings", "DeploymentInfo", "Signup"];
